/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { observable } from 'mobx';
/**
 * SelectYourFoundation Input Action
 */
export class ProductCompareBuyboxStateSharing implements Msdyn365.IActionInput {
    @observable public zipCode?: string | undefined;
    //   Construct the input needed to run the action
    constructor(zipCode: string | undefined) {
        this.zipCode = zipCode;
    }

    //   Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `ProductCompareBuyboxStateSharing`;
    public getCacheObjectType = () => 'ProductCompareBuyboxStateSharing';
    public dataCacheType = (): Msdyn365.CacheType => 'request';
}

//   Create a data model here or import one to capture the response of the action
export interface ISelectYourFoundationData {
    zipCode: string | undefined;
}

/**
 *   Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext<ISelectYourFoundationData>): Msdyn365.IActionInput => {
    return new ProductCompareBuyboxStateSharing(args?.config?.zipCode);
};

/**
 *   Use this function to call your action and process the results as needed
 */
async function action(input: ProductCompareBuyboxStateSharing, ctx: Msdyn365.IActionContext): Promise<ISelectYourFoundationData> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    //   Uncomment the below line to get the value from a service
    // const response = await Msdyn365.sendRequest<ISelectYourFoundationData[]>('/get/example/id/1', 'get');
    return { zipCode: input.zipCode };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<ISelectYourFoundationData>>action,
    //   Give your data action a unique id
    id: 'ProductCompareBuyboxStateSharing',
    input: createInput
    //   Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
